import React, { useState, useEffect, useRef } from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import MenuIcon from "@mui/icons-material/Menu";
import PublicIcon from "@mui/icons-material/Public";
import Avatar from "@mui/material/Avatar";
import GlobalSnackbar from "../../shared/utils/GlobalSnackbar";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import JPG from "../../../src/shared/assets/icons/JPG.png";
import PNG from "../../../src/shared/assets/icons/PNG.png";
import PDF from "../../../src/shared/assets/icons/PDF.png";
import CommentIcon from "@mui/icons-material/Comment";
import CapitalizeFirstLetter from "../../shared/utils/CapitalizeFirstLetter";
import MenuButtonWithDatePickers from "../../shared/utils/DateFilter";
import Decrypt from "../../shared/utils/Decrypt";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReferenceAssignmentModal from "../../components/AdminportalFolder/InstallationPartnerDetails/Slots/ReferenceAssignmentModal.jsx";
import GlobalButton from "../../shared/utils/GlobalButton.jsx";

import {
  FormControl,
  InputLabel,
  Select,
  Menu,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import {
  CircularProgress,
  Tooltip,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Styles from "../../styles/vendorDashboard.module.css";
import FormatDateTimestamp from "../../helperFunctions/FormatDateTimestamp";
import InstallationPartnerOnboardingForm from "../../shared/createForms/installationPartnerOnboardingForm";
import InstallationPartnerModal from "./InstallationPartnerDetails/InstallationPartnerModal";
import CustomLoading from "../../shared/utils/CustomLoading";
import AddIcon from "@mui/icons-material/Add";
import OtpVerificationModal from "../../shared/utils/OtpVerificationModal";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import {
  Edit,
  Trash,
  ViewIcon,
  User_plus,
  DocumentFile,
} from "../../shared/assets/icons/index";
import IpPaymentsModal from "../../shared/createForms/IpPaymentsModal";
import CreateSlotIP from "./InstallationPartnerDetails/Slots/CreateSlotIP";
import ViewSlotsInstallationPartner from "./InstallationPartnerDetails/Slots/ViewSlotsInstallationPartner";
import TableViewIcon from "@mui/icons-material/TableView";
import GoogleMapModal from "../../shared/utils/GoogleMapModal";
import TableRowsIcon from "@mui/icons-material/TableRows";
import styles from "../../styles/adminPortal.module.css";
import CommentModal from "../../shared/createForms/CommentModal";
import DeletedUsersRestore from "../../shared/createForms/DeletedUsersRestore.jsx";
import { PersonAddAlt } from "@mui/icons-material";
import IPAssignModal from "./Campaign/IpAssignModal.js";

function EnhancedTableHead(props) {
  let role = localStorage.getItem("role");

  // Check if any search filters are active
  const hasActiveFilters = Object.values(props.searchInputs || {}).some(
    (value) => value && value.toString().trim() !== "",
  );

  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {props.headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}>{headCell.label} </span>
            <div className={styles.topBorderDiv}>
              {[
                "state",
                "city",
                ...(role == "-1" || role == "4" ? ["phoneNumber"] : []),
                "name",
                "itiCourse",
                "addedBy",
                "updatedBy",
                "source",
              ].includes(headCell.id) && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder={`Search`}
                  onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                  value={props.searchInputs?.[headCell.id] || ""}
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>

      {/* Only show count when there are active filters AND filteredIPCount > 0 */}
      {props.filteredIPCount > 0 && hasActiveFilters && (
        <TableRow>
          <TableCell
            colSpan={props.headCells.length}
            sx={{
              backgroundColor: "#DEEBFF",
              position: "relative",
              paddingBottom: "2rem",
            }}
          >
            <div className="fixed left-1/2 transform -translate-x-1/2 text-sm font-medium">
              {`${props.filteredIPCount} Installation Partners`}
            </div>
          </TableCell>
        </TableRow>
      )}
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [clearDateFilter, setClearDateFilter] = useState(false);
  const [rotate, setRotate] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dateFilterAnchorEl, setDateFilterAnchorEl] = useState(null);
  const serverURL = process.env.REACT_APP_URL;

  const handleDateClick = (event) => {
    setDateFilterAnchorEl(event.currentTarget);
  };
  const handleDateChange = (e) => {
    if (e?.dateFilter) {
      props.setSearchInputs((prev) => ({
        ...prev,
        fromDate: e.dateFilter.fromDate,
        toDate: e.dateFilter.toDate,
      }));
    }
    setDateFilterAnchorEl(null);
    setMobileMenuOpen(false);
  };

  const handleDateClose = () => {
    setDateFilterAnchorEl(null);
  };

  const { numSelected } = props;
  const handleOpen = (e) => {
    props.OnModalOpen(true);
    props.setSelectedInstallationPartnerData({});
    setMobileMenuOpen(false);
  };

  const handleTrashOpen = async (e) => {
    await props.getALLDeletedIps();
    props.OnTrashModalOpen(true);
  };

  const handleMapOpen = () => {
    props.setIsMapState(true);
    setMobileMenuOpen(false);
  };
  const handleTableOpen = () => {
    props.setIsMapState(false);
    setMobileMenuOpen(false);
  };
  const handleModal = () => {
    props.setCreateModal(true);
    setMobileMenuOpen(false);
  };

  const handelViewSlot = () => {
    props.setSlotModalView(true);
    setMobileMenuOpen(false);
  };

  const handleClickRefresh = () => {
    setClearDateFilter(true);
    // Clean all filters
    props.setSearchInputs({
      state: "",
      city: "",
      phoneNumber: "",
      name: "",
      iticourse: "",
      addedBy: "",
      updatedBy: "",
      fromDate: "",
      toDate: "",
      source: "",
    });

    setRotate(true);
    props.userVenderData();
    props.setPageSize(10);
    setTimeout(() => setRotate(false), 500);
    setMobileMenuOpen(false);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Handle mobile menu open/close
  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="border-b flex justify-between items-center h-14 pt-2">
      {!isMobile && (
        <>
          <div className="font-bold text-md text-gray-600">
            Total Installation Partner: {props.totalInstallationPartner}
          </div>
          <div className="flex">
            <Tooltip title="Refresh">
              <IconButton
                onClick={handleClickRefresh}
                sx={{
                  animation: rotate
                    ? "rotateAnimation 0.5s ease-in-out"
                    : "none",
                  "@keyframes rotateAnimation": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            {(localStorage.getItem("role") == "-1" ||
              localStorage.getItem("role") == "1" ||
              localStorage.getItem("role") == "4") && (
              <>
                <Tooltip title="Map view">
                  <IconButton onClick={handleMapOpen}>
                    <PublicIcon
                      sx={{
                        backgroundColor: props.isMapState
                          ? "#418cff"
                          : "inherit",
                        color: props.isMapState ? "#ffff" : "inherit",
                        borderRadius: 2,
                        strokeWidth: 1.5,
                        p: "2px",
                      }}
                    />
                  </IconButton>
                </Tooltip>

                <div className="mr-2">
                  <Tooltip title="Table view">
                    <IconButton onClick={handleTableOpen}>
                      <TableRowsIcon
                        sx={{
                          backgroundColor: props.isMapState
                            ? "inherit"
                            : "#418cff",
                          color: props.isMapState ? "inherit" : "#fff",
                          borderRadius: 2,
                          strokeWidth: 1.5,
                          p: "2px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
                {/* Date Filter Button */}
                <div className="date-filter">
                  <MenuButtonWithDatePickers
                    onSubmit={handleDateChange}
                    anchorEl={dateFilterAnchorEl}
                    setAnchorEl={setDateFilterAnchorEl}
                    handleClose={handleDateClose}
                    handleClick={handleDateClick}
                    clearDateFilter={clearDateFilter}
                  />
                </div>
              </>
            )}

            {localStorage.getItem("role") == "-1" && (
              <Tooltip title="Create Slot">
                <IconButton onClick={handleModal}>
                  <AddIcon sx={{ color: "#666666" }} />
                </IconButton>
              </Tooltip>
            )}
            {localStorage.getItem("role") == "-1" && (
              <Tooltip title="View Slot">
                <IconButton onClick={handelViewSlot}>
                  <TableViewIcon sx={{ color: "#666666" }} />
                </IconButton>
              </Tooltip>
            )}
            {localStorage.getItem("role") != "1" && (
              <Tooltip title="Add Installation Partner">
                <IconButton onClick={handleOpen}>
                  <User_plus sx={{ color: "#666666" }} />
                </IconButton>
              </Tooltip>
            )}
            {localStorage.getItem("role") == "-1" && (
              <Tooltip title="Trash">
                <IconButton onClick={handleTrashOpen}>
                  <DeleteIcon sx={{ color: "#666666" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </>
      )}

      {isMobile && (
        <div className="flex justify-between items-center w-full">
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="p"
            id="tableTitle"
            component="div"
          >
            Total Installation Partner: {props.totalInstallationPartner}
          </Typography>
          <IconButton color="inherit" onClick={handleMobileMenuOpen}>
            <MenuIcon />
          </IconButton>
        </div>
      )}

      {/* Enhanced Mobile Dialog with all functionality */}
      <Dialog
        open={mobileMenuOpen}
        onClose={handleMobileMenuClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle className="flex justify-between items-center">
          <span>Actions</span>
          <IconButton onClick={handleMobileMenuClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {/* Refresh - Always visible */}
          <div
            className="flex justify-start border items-center mb-2 rounded-md p-2 hover:bg-gray-50 cursor-pointer"
            onClick={handleClickRefresh}
          >
            <IconButton>
              <RefreshIcon sx={{ color: "var(--heading-color)" }} />
            </IconButton>
            <div className="ml-2">
              <p className="font-medium">Refresh</p>
            </div>
          </div>

          {/* Map/Table view and Date Filter for specific roles */}
          {(localStorage.getItem("role") == "-1" ||
            localStorage.getItem("role") == "1" ||
            localStorage.getItem("role") == "4") && (
            <>
              {/* Map View */}
              <div
                className="flex justify-start border items-center mb-2 rounded-md p-2 hover:bg-gray-50 cursor-pointer"
                onClick={handleMapOpen}
              >
                <IconButton>
                  <PublicIcon sx={{ color: "var(--heading-color)" }} />
                </IconButton>
                <div className="ml-2">
                  <p className="font-medium">Map View</p>
                </div>
              </div>

              {/* Table View */}
              <div
                className="flex justify-start border items-center mb-2 rounded-md p-2 hover:bg-gray-50 cursor-pointer"
                onClick={handleTableOpen}
              >
                <IconButton>
                  <TableRowsIcon sx={{ color: "var(--heading-color)" }} />
                </IconButton>
                <div className="ml-2">
                  <p className="font-medium">Table View</p>
                </div>
              </div>

              {/* Date Filter */}
              <div className="flex justify-start border items-center mb-2 rounded-md px-4 py-2 hover:bg-gray-50 cursor-pointer">
                <MenuButtonWithDatePickers
                  onSubmit={handleDateChange}
                  anchorEl={dateFilterAnchorEl}
                  setAnchorEl={setDateFilterAnchorEl}
                  handleClose={handleDateClose}
                  handleClick={handleDateClick}
                  clearDateFilter={clearDateFilter}
                  mobileView={true}
                />
                <div onClick={handleDateClick} className="ml-2">
                  <p className="font-medium">Date Filter</p>
                </div>
              </div>
            </>
          )}

          {/* Slot actions for role -1 */}
          {localStorage.getItem("role") == "-1" && (
            <>
              {/* Create Slot */}
              <div
                className="flex justify-start border items-center mb-2 rounded-md p-2 hover:bg-gray-50 cursor-pointer"
                onClick={handleModal}
              >
                <IconButton>
                  <AddIcon sx={{ color: "var(--heading-color)" }} />
                </IconButton>
                <div className="ml-2">
                  <p className="font-medium">Create Slot</p>
                </div>
              </div>

              {/* View Slot */}
              <div
                className="flex justify-start border items-center mb-2 rounded-md p-2 hover:bg-gray-50 cursor-pointer"
                onClick={handelViewSlot}
              >
                <IconButton>
                  <TableViewIcon sx={{ color: "var(--heading-color)" }} />
                </IconButton>
                <div className="ml-2">
                  <p className="font-medium">View Slot</p>
                </div>
              </div>
            </>
          )}

          {/* Add Installation Partner */}
          {localStorage.getItem("role") != "1" &&
            localStorage.getItem("role") != "4" && (
              <div
                className="flex justify-start border items-center mb-2 rounded-md p-2 hover:bg-gray-50 cursor-pointer"
                onClick={handleOpen}
              >
                <IconButton>
                  <User_plus sx={{ color: "var(--heading-color)" }} />
                </IconButton>
                <div className="ml-2">
                  <p className="font-medium">Add Installation Partner</p>
                </div>
              </div>
            )}
        </DialogContent>
        <DialogActions>
          <GlobalButton
            variant="tertiary"
            size="small"
            onClick={handleMobileMenuClose}
          >
            {`Close`}
          </GlobalButton>
        </DialogActions>
      </Dialog>

      {/* Date Filter Menu - This should be outside the mobile dialog */}
      <Menu
        anchorEl={dateFilterAnchorEl}
        open={Boolean(dateFilterAnchorEl)}
        onClose={handleDateClose}
      >
        {/* Your date picker component would go here */}
        <MenuItem>
          <MenuButtonWithDatePickers
            onSubmit={handleDateChange}
            anchorEl={dateFilterAnchorEl}
            setAnchorEl={setDateFilterAnchorEl}
            handleClose={handleDateClose}
            handleClick={handleDateClick}
            clearDateFilter={clearDateFilter}
          />
        </MenuItem>
      </Menu>
    </div>
  );
}
var oldData = [];
export default function EnhancedTable() {
  // Declare states
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImage, setIsImage] = useState(false);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);

  const truncateText = (text, maxLength = 20) => {
    if (!text) return "";
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  const handleImageClickPhoto = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsImage(true);
  };
  const email = localStorage.getItem("superAdminEmail"); // Replace with the actual email to which the OTP should be sent
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [otpError, setOtpError] = useState("");
  const firstInputRef = useRef(null);
  const [isVerified, setIsVerified] = useState(false);
  const [details, setDetails] = useState(null);
  const [isModalOtpOpen, setIsModalOtpOpen] = useState(false);
  const [pageSize, setPageSize] = useState(100);
  const pageSizeOptions = [1, 5, 10, 50, 100, 200];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allDeletedIps, setAllDeletedIps] = useState([]);
  const [isTrashModalOpen, setIsTrashModalOpen] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [slotModalView, setSlotModalView] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isMapState, setIsMapState] = useState(false);
  const [ipPayment, setIpPayment] = useState([]);
  const [ipCampaignData, setIpCampaignData] = useState([]);
  const [ipId, setIpId] = useState("");

  const [filteredIPCount, setFilteredIPCount] = useState(0);
  const [isInstallationPartnerModalOpen, setIsInstallationPartnerModalOpen] =
    useState(false);
  const [installationPartner, setInstallationPartner] = useState([]);

  const [selectedInstallationPartnerData, setSelectedInstallationPartnerData] =
    useState({});
  const [installationPartnerListLoading, setInstallationPartnerLoading] =
    useState(true);
  const [openIPModal, setOpenIPModal] = useState(false);

  const [totalInstallationPartner, setTotalInstallationPartner] = useState("0");
  let debounceTimeout = null;
  const [isTrashLoading, setTrashLoading] = useState(false);

  const [commentModal, setCommentModal] = useState(false);
  const [idforView, setIdForView] = useState(null);
  const [idforEdit, setIdForEdit] = useState(null);
  const [comment, setComment] = useState("");

  const [ipModalOpen, setIpModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null); // Store the selected row ID
  const [searchInputs, setSearchInputs] = useState({
    state: "",
    city: "",
    phoneNumber: "",
    name: "",
    iticourse: "",
    addedBy: "",
    updatedBy: "",
    fromDate: "",
    toDate: "",
    source: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [headCells, setHeadCells] = useState([]);

  useEffect(() => {
    const role = parseInt(localStorage.getItem("role"));

    const baseHeadCells = [
      { id: "name", label: "Name", width: 200 },
      { id: "email", label: "Email", width: 200 },
      { id: "phoneNumber", label: "Phone Number", width: 160 },
      ...(role !== 1 && role !== 4
        ? [{ id: "document", label: "Test Document", width: 180 }]
        : []),
      { id: "document", label: "Certifications", width: 300 },
      { id: "itiCourse", label: "ITI Course", width: 200 },
      { id: "state", label: "State", width: 160 },
      { id: "city", label: "City", width: 140 },
      { id: "createdAt", label: "Added On", width: 160 },
      { id: "addedBy", label: "Added By", width: 150 },
      { id: "updatedBy", label: "Updated By", width: 150 }, // Added this line
      ...(role == -1 || role == 0 || role == 4
        ? [{ id: "assignVP", label: "Assign VP", width: 150 }]
        : []), // Added this line
      {
        id: "source",
        label: "Source",
        width: 200,
        tooltip: "User who referred this IP (App onboardings only)",
      },
      ...(role !== 1 ? [{ id: "action", label: "Action", width: 80 }] : []),
    ];

    setHeadCells(baseHeadCells);
  }, []);

  const MapFor = "installationPartner";
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const getInstallationPartnerList = async (page = 1, limit = 100) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/installationPartner/view?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setTotalInstallationPartner(response?.data?.totalRecords);
        setInstallationPartner(response?.data?.data);
        oldData = response?.data?.data;
        setTotalPages(response?.data?.totalPages);
        setInstallationPartnerLoading(false);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    }
  };
  // Add function to fetch users
  const fetchUsers = async () => {
    try {
      setLoadingUsers(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/users/key-account-managers`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setUsers(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadingUsers(false);
    }
  };
  useEffect(() => {
    fetchUsers();
  }, []);
  const getALLDeletedIps = async () => {
    try {
      setTrashLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/installationPartner/allDeletedIps`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setAllDeletedIps(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    } finally {
      setTrashLoading(false);
    }
  };

  useEffect(() => {
    // Only filter if both dates are set
    if (searchInputs.fromDate && searchInputs.toDate) {
      const queryParams = new URLSearchParams();
      Object.entries(searchInputs).forEach(([key, value]) => {
        if (value && value.trim() !== "") {
          queryParams.append(key, value);
        }
      });
      queryParams.append("page", 1);
      queryParams.append("limit", pageSize);
      fetchIps(queryParams.toString());
    }
  }, [searchInputs.fromDate, searchInputs.toDate]);

  useEffect(() => {
    getInstallationPartnerList(page, pageSize);
  }, []);

  const handleModalOpen = (value) => {
    setIsModalOpen(value);
  };

  const handleEditModal = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);
    axios
      .get(`${serverURL}/installationPartner/view/${v._id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Decrypt email and phone number
          let installationPartnerData = response.data.data;
          installationPartnerData = {
            ...installationPartnerData,
            emailAddress: installationPartnerData.emailAddress
              ? Decrypt(installationPartnerData.emailAddress)
              : null,
            phoneNumber: installationPartnerData.phoneNumber
              ? Decrypt(installationPartnerData.phoneNumber)
              : null,
          };

          // Set the decrypted data in state
          setSelectedInstallationPartnerData(installationPartnerData);

          // Handle modal based on the operation type
          if (operation === "edit") {
            setIsModalOpen(true);
          } else if (operation === "payments") {
            setIpModalOpen(true);
          } else {
            setIsInstallationPartnerModalOpen(true);
          }
          setIsActionLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching InstallationPartner:", error);
        setIsActionLoading(false);
      });
  };

  const handlePaymentClick = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);
    axios
      .get(
        `${serverURL}/installationPartner/installationPartnerPaymentsDetails/${v._id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      )
      .then((response) => {
        if (response.data.success) {
          setIpPayment(response?.data?.data);
          setSelectedInstallationPartnerData(
            response.data.installationPartnerData,
          );
          setIpCampaignData(response?.data?.totalPayments);
          setIpModalOpen(true);
          setIsActionLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching InstallationPartner:", error);

        setIsActionLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Payment details could not be fetched. Please try again later.",
        });
      });
  };

  const handleViewModal = (e, v, operation) => {
    setIsActionLoading(true);
    setAnchorEl(null);

    axios
      .get(`${serverURL}/installationPartner/view/${v}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Get the installation partner data
          let installationPartnerData = response.data.data;

          // Decrypt email and phone number
          installationPartnerData = {
            ...installationPartnerData,
            emailAddress: installationPartnerData.emailAddress
              ? Decrypt(installationPartnerData.emailAddress)
              : null,
            phoneNumber: installationPartnerData.phoneNumber
              ? Decrypt(installationPartnerData.phoneNumber)
              : null,
          };

          // Set the decrypted data
          setSelectedInstallationPartnerData(installationPartnerData);

          // Handle modal based on the operation type
          if (operation === "view") {
            setIsModalOpen(true);
          } else {
            setIsInstallationPartnerModalOpen(true);
          }

          setIsActionLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching installationPartner:", error);
        setIsActionLoading(false);
      });
  };

  const handleDelete = (e, v) => {
    e.preventDefault();
    setAnchorEl(null);

    Swal.fire({
      icon: "error",
      text: "Do you want to delete?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axios
            .delete(`${serverURL}/installationPartner/delete/${v._id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then((response) => {
              setSnackbar({
                open: true,
                message: response.data.message,
                severity: "success",
              });
              const queryParams = new URLSearchParams();

              Object.entries(searchInputs).forEach(([key, value]) => {
                if (value?.trim()) {
                  queryParams.append(key, value);
                }
              });

              queryParams.append("page", 1);
              queryParams.append("limit", pageSize);

              fetchIps(queryParams.toString());
            })
            .catch((error) => {
              console.error("Error deleting InstallationPartner:", error);
              Swal.fire("There was an error deleting the InstallationPartner.");
            });
        } catch (error) {
          console.error(error);
          Swal.fire("There was an error deleting the InstallationPartner.");
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not deleted", "", "info");
      }
    });
  };

  const handlePageChange = async (e, value) => {
    setPage(value); // Update the page state

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    queryParams.append("page", value);
    queryParams.append("limit", pageSize); // Assuming pageSize is the number of items per page
    await fetchIps(queryParams.toString()); // Fetch first page with new page size
  };

  const handlePageSizeChange = async (e) => {
    const newSize = parseInt(e.target.value, 10);
    setPageSize(newSize);

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add the new page and page size to the query params
    queryParams.append("page", 1);
    queryParams.append("limit", newSize);

    await fetchIps(queryParams.toString()); // Fetch first page with new page size
  };

  const handleIconOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId); // Set the selected row ID
  };
  const handleIconClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null); // Reset the selected row ID
  };

  const fetchIps = async (queryParams) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/installationPartner/view?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setInstallationPartner(response?.data?.data);
        setTotalPages(response?.data?.totalPages);
        setFilteredIPCount(response?.data?.totalRecords);
        setPage(response?.data?.currentPage);
      }
    } catch (error) {
      console.error("Error fetching filtered vendors:", error);
    } finally {
    }
  };

  const handleSearchChangeHead = async (e, key) => {
    const value = e.target.value.toLowerCase();

    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      const allFieldsEmpty = Object.values(updatedInputs).every(
        (val) => val.trim() === "",
      );

      if (allFieldsEmpty) {
        getInstallationPartnerList(1, pageSize);
        setFilteredIPCount(0);
        return updatedInputs;
      }

      if (debounceTimeout) clearTimeout(debounceTimeout);

      // Set a new timeout of 3 seconds before sending the API request
      // debounceTimeout = setTimeout(() => {
      // Construct API Query Parameters based on filled fields
      let queryParams = new URLSearchParams();

      Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
        if (searchValue.trim() !== "") {
          queryParams.append(searchKey, searchValue);
        }
      });

      // Add pagination info (page and limit) to the queryParams
      queryParams.append("page", 1); // Current page
      queryParams.append("limit", pageSize); // Number of rows per page

      // Call API with filtered search parameters after 3 seconds
      fetchIps(queryParams.toString());
      // }, 1000); // Delay of 3000ms (3 seconds)

      return updatedInputs;
    });
  };

  const handleSendOtp = async (email, type) => {
    try {
      // Display a SweetAlert2 confirmation dialog
      const result = await Swal.fire({
        title: `<span className="text-2xl ">Do you want to ${
          type === "edit" ? "edit" : "view"
        } the details?</span>`,

        text: "Click 'Yes' to send OTP, or 'No' to cancel.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6", // "Yes" button color
        cancelButtonColor: "#d33", // "No" button color
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });

      // Check if the user clicked "Yes"
      if (result.isConfirmed) {
        Swal.fire({
          title: "Sending OTP...",
          html: "Please wait while we send the OTP to your email.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // Proceed with sending OTP
        const response = await axios.post(
          `${serverURL}/client/send-otp`,
          { email }, // Request body
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        Swal.close();

        // Show success alert
        await Swal.fire(
          "Success!",
          `OTP sent successfully to ${email}`,
          // 'OTP sent successfully.',
          "success",
        );

        // Open the OTP modal after successful OTP send
        setIsModalOtpOpen(true);
      } else {
        // If the user clicked "No"
        await Swal.fire("Cancelled", "OTP request cancelled.", "info");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);

      Swal.close();

      // Show an error alert if something goes wrong
      await Swal.fire(
        "Error",
        "An error occurred while sending OTP. Please try again later.",
        "error",
      );
    }
  };

  const handleClose = () => {
    setCommentModal(false);
    setComment("");
  };

  const handleViewClick = (e, id, option) => {
    if (
      localStorage.getItem("role") !== "-1" &&
      localStorage.getItem("role") !== "1" &&
      localStorage.getItem("role") !== "0" &&
      localStorage.getItem("role") !== "4"
    ) {
      handleSendOtp(email, "view");
    } else {
      handleViewModal(e, id, "read");
    }

    setIsModalOtpOpen(false);
    setIdForView(id);
  };
  const handleEditClick = (e, id, option) => {
    if (
      localStorage.getItem("role") !== "-1" &&
      localStorage.getItem("role") !== "0" &&
      localStorage.getItem("role") !== "4"
    ) {
      handleSendOtp(email, "edit");
    } else {
      handleEditModal(e, id, "edit");
    }

    setIsModalOtpOpen(false);
    setIdForEdit(id);
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[0-9]*$/.test(value)) {
      // Allow only numeric values
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Clear error when user starts typing again
      if (otpError) {
        setOtpError("");
      }

      // Automatically focus the next input if value is entered
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }

      // Check if all OTP fields are filled
      const isOtpComplete = newOtp.every((digit) => digit !== "");
      setIsVerified(isOtpComplete);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        // Move to previous input on backspace if current is empty
        document.getElementById(`otp-input-${index - 1}`).focus();
      } else if (otp[index]) {
        // Clear current input and stay there
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const otpString = String(otp.join(""));

      // Basic validation
      if (otpString.length !== 6) {
        setOtpError("Please enter a complete 6-digit OTP");
        return;
      }

      const response = await axios.post(`${serverURL}/client/verify-otp`, {
        email,
        otp: otpString,
      });

      if (response.data.success) {
        // Check if idforView or idforEdit is set in state and call respective modal
        if (idforView) {
          handleViewModal("", idforView, "read");
        } else if (idforEdit) {
          handleEditModal("", idforEdit, "edit");
        }

        setDetails(response.data.details);
        setIsModalOtpOpen(false);
        setOtpError(""); // Clear error message on success
        setOtp(Array(6).fill(""));
        setIsVerified(false); // Reset verification state
      } else {
        setOtpError("OTP is not verified. Please try again.");
        // Clear OTP fields on error like in the reference code
        setOtp(Array(6).fill(""));
        setIsVerified(false);

        // Focus back to first input
        if (firstInputRef.current) {
          firstInputRef.current.focus();
        }
      }
    } catch (error) {
      setOtpError("OTP is not verified. Please try again.");
      // Clear OTP fields on error
      setOtp(Array(6).fill(""));
      setIsVerified(false);

      // Focus back to first input
      if (firstInputRef.current) {
        firstInputRef.current.focus();
      }

      console.error("Error verifying OTP:", error);
    }
  };

  const resetModal = () => {
    setOtp(Array(6).fill("")); // Reset OTP inputs
    setIsVerified(false); // Reset verification status
    setOtpError(""); // Clear errors
  };

  const handleModalClose = () => {
    resetModal();
    setIsModalOtpOpen(false); // Close modal
  };
  return (
    <div className={styles.tableGround}>
      <Box>
        {!installationPartnerListLoading ? (
          <Paper
            sx={{ width: "100%", boxShadow: "none" }}
            className={styles.tableGap}
          >
            <EnhancedTableToolbar
              userVenderData={getInstallationPartnerList}
              setPageSize={setPageSize}
              // InstallationPartner={InstallationPartner}
              setCreateModal={setCreateModal}
              setSlotModalView={setSlotModalView}
              OnModalOpen={(value) => handleModalOpen(value)}
              onSearchChange={(value) => handleSearchChangeHead(value)}
              totalInstallationPartner={totalInstallationPartner}
              setSelectedInstallationPartnerData={
                setSelectedInstallationPartnerData
              }
              OnTrashModalOpen={setIsTrashModalOpen}
              setSearchInputs={setSearchInputs}
              setAllDeletedIps={setAllDeletedIps}
              setIsMapState={setIsMapState}
              isMapState={isMapState}
              setTrashLoading={setTrashLoading}
              getALLDeletedIps={getALLDeletedIps}
            />
            {isMapState ? (
              <>
                <GoogleMapModal
                  setIsMapState={setIsMapState}
                  locationCoordinates={installationPartner}
                  MapFor={MapFor}
                />
              </>
            ) : (
              <>
                <TableContainer
                  className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
                >
                  <Table
                    stickyHeader
                    // sx={{ minWidth: 750 }}
                    className="rounded-lg "
                  >
                    <EnhancedTableHead
                      rowCount={installationPartner?.length}
                      headCells={headCells}
                      userListData={getInstallationPartnerList}
                      setSearchInputs={setSearchInputs} // Function to update search inputs
                      handleSearchChangeHead={handleSearchChangeHead}
                      searchInputs={searchInputs}
                      filteredIPCount={filteredIPCount}
                    />

                    {installationPartner && installationPartner?.length > 0 ? (
                      <TableBody>
                        {installationPartner.map((v, index) => {
                          const role = localStorage.getItem("role");
                          return (
                            <TableRow
                              hover
                              className={styles.tableRowHead}
                              tabIndex={-1}
                              key={v._id}
                              onClick={(e) => {
                                handleViewClick(e, v._id, "read"); // Perform the intended action
                              }}
                            >
                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  const name = CapitalizeFirstLetter(v?.name);
                                  const maxLength = 20;
                                  const displayText =
                                    name.length > maxLength
                                      ? name.slice(0, maxLength) + "..."
                                      : name;

                                  return (
                                    <Tooltip
                                      title={name}
                                      arrow
                                      placement="top"
                                      disableHoverListener={
                                        name.length <= maxLength
                                      }
                                    >
                                      <span className="flex flex-row items-center gap-2">
                                        <Avatar
                                          className="custom-avatar"
                                          style={{
                                            background:
                                              "var(--light-primary-color)",
                                            color: "var(--primary-color)",
                                          }}
                                          variant="rounded"
                                        >
                                          {CapitalizeFirstLetter(
                                            v?.name?.charAt(0),
                                          )}
                                        </Avatar>
                                        <span className="truncate max-w-[180px]">
                                          {displayText}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  const originalEmail =
                                    v?.emailAddress || "N/A";
                                  const maskedEmail =
                                    role === "-1" ||
                                    role === "0" ||
                                    role === "4"
                                      ? originalEmail
                                      : `**********${Decrypt(
                                          originalEmail,
                                        )?.slice(-7)}`;

                                  // Truncate if longer than 17 characters
                                  const maxLength = 25;
                                  const displayEmail =
                                    maskedEmail.length > maxLength
                                      ? maskedEmail.substring(0, maxLength) +
                                        "..."
                                      : maskedEmail;

                                  return (
                                    <Tooltip
                                      title={originalEmail} // Show full email on hover
                                      arrow
                                      placement="top"
                                      disableHoverListener={
                                        maskedEmail.length <= maxLength
                                      } // Avoid tooltip when full email is shown
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "inline-block",
                                          maxWidth: "100%",
                                        }}
                                      >
                                        {displayEmail}
                                      </span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                <span>
                                  {role === "-1" || role === "0" || role === "4"
                                    ? v?.phoneNumber
                                    : `******${Decrypt(v?.phoneNumber)?.slice(
                                        -4,
                                      )}`}{" "}
                                </span>
                              </TableCell>
                              {role != "1" && role != "4" && (
                                <TableCell
                                  className={styles.tableRow}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {(v?.documentForTest && (
                                    <a
                                      href={v?.documentForTest} // The document URL
                                      target="_blank" // Open in a new tab
                                      rel="noopener noreferrer" // Security best practice
                                      className="text-blue-500 hover:underline"
                                    >
                                      <span>View Certificate</span>
                                    </a>
                                  )) || (
                                    <span className="text-red-500 cursor-default">
                                      No Certificates Available
                                    </span>
                                  )}
                                </TableCell>
                              )}
                              <TableCell
                                className={styles.tableRow}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="flex place-items-start justify-start gap-2">
                                  {v?.diplomaCertificate && (
                                    <Tooltip
                                      title="Diploma Certificate"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() =>
                                          handleImageClickPhoto(
                                            v.diplomaCertificate,
                                          )
                                        }
                                        size="small"
                                      >
                                        <img
                                          src={
                                            v.diplomaCertificate.endsWith(
                                              ".pdf",
                                            )
                                              ? PDF
                                              : v.diplomaCertificate.endsWith(
                                                    ".png",
                                                  )
                                                ? PNG
                                                : JPG
                                          }
                                          alt="Diploma Certificate"
                                          className="w-8 h-10 object-contain"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}

                                  {v?.graduationCertificate && (
                                    <Tooltip
                                      title="Graduation Certificate"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() =>
                                          handleImageClickPhoto(
                                            v.graduationCertificate,
                                          )
                                        }
                                        size="small"
                                      >
                                        <img
                                          src={
                                            v.graduationCertificate.endsWith(
                                              ".pdf",
                                            )
                                              ? PDF
                                              : v.graduationCertificate.endsWith(
                                                    ".png",
                                                  )
                                                ? PNG
                                                : JPG
                                          }
                                          alt="Graduation Certificate"
                                          className="w-8 h-10 object-contain"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}

                                  {v?.itiCertificate && (
                                    <Tooltip
                                      title={`ITI Certificate${
                                        v?.itiCourse ? ` (${v?.itiCourse})` : ""
                                      }`}
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() =>
                                          handleImageClickPhoto(
                                            v?.itiCertificate,
                                          )
                                        }
                                        size="small"
                                      >
                                        <img
                                          src={
                                            v?.itiCertificate.endsWith(".pdf")
                                              ? PDF
                                              : v?.itiCertificate.endsWith(
                                                    ".png",
                                                  )
                                                ? PNG
                                                : JPG
                                          }
                                          alt="ITI Certificate"
                                          className="w-8 h-10 object-contain"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}

                                  {v?.tenthCertificate && (
                                    <Tooltip
                                      title="10th Certificate"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() =>
                                          handleImageClickPhoto(
                                            v?.tenthCertificate,
                                          )
                                        }
                                        size="small"
                                      >
                                        <img
                                          src={
                                            v?.tenthCertificate.endsWith(".pdf")
                                              ? PDF
                                              : v?.tenthCertificate.endsWith(
                                                    ".png",
                                                  )
                                                ? PNG
                                                : JPG
                                          }
                                          alt="10th Certificate"
                                          className="w-8 h-10 object-contain"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}

                                  {v?.twelfthCertificate && (
                                    <Tooltip
                                      title="12th Certificate"
                                      arrow
                                      placement="top"
                                    >
                                      <IconButton
                                        onClick={() =>
                                          handleImageClickPhoto(
                                            v.twelfthCertificate,
                                          )
                                        }
                                        size="small"
                                      >
                                        <img
                                          src={
                                            v.twelfthCertificate.endsWith(
                                              ".pdf",
                                            )
                                              ? PDF
                                              : v.twelfthCertificate.endsWith(
                                                    ".png",
                                                  )
                                                ? PNG
                                                : JPG
                                          }
                                          alt="12th Certificate"
                                          className="w-8 h-10 object-contain"
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  )}

                                  {!v?.diplomaCertificate &&
                                    !v?.graduationCertificate &&
                                    !v?.itiCertificate &&
                                    !v?.tenthCertificate &&
                                    !v?.twelfthCertificate && (
                                      <span className="text-red-500 cursor-default">
                                        No Certificates Available
                                      </span>
                                    )}
                                </div>

                                {/* Image Preview Modal */}
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  const itiCourse =
                                    v.itiCourse || "Not Available";

                                  // Truncate if length > 18
                                  const maxLength = 20;
                                  const displayText =
                                    itiCourse.length > maxLength
                                      ? itiCourse.slice(0, maxLength) + "..."
                                      : itiCourse;

                                  return (
                                    <Tooltip
                                      title={itiCourse}
                                      arrow
                                      placement="top"
                                      disableHoverListener={
                                        itiCourse.length <= maxLength
                                      }
                                    >
                                      <span>{displayText}</span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>

                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  const state = v?.state || "N/A";
                                  const maxLength = 20;
                                  const displayText =
                                    state.length > maxLength
                                      ? state.slice(0, maxLength) + "..."
                                      : state;

                                  return (
                                    <Tooltip
                                      title={state}
                                      arrow
                                      placement="top"
                                      disableHoverListener={
                                        state.length <= maxLength
                                      }
                                    >
                                      <span>{displayText}</span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  const city = v.city || "N/A";

                                  // Truncate if longer than 17 characters
                                  const maxLength = 25;
                                  const displayText =
                                    city.length > maxLength
                                      ? city.substring(0, maxLength) + "..."
                                      : city;

                                  return (
                                    <Tooltip
                                      title={city} // Show full city name on hover
                                      arrow
                                      placement="top"
                                      disableHoverListener={
                                        city.length <= maxLength
                                      }
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "inline-block",
                                          maxWidth: "100%",
                                        }}
                                      >
                                        {displayText}
                                      </span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>

                              <TableCell className={styles.tableRow}>
                                {" "}
                                <FormatDateTimestamp timestamp={v.createdAt} />
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  const addedByName = v?.addedBy?.name
                                    ? CapitalizeFirstLetter(v?.addedBy?.name)
                                    : "Self";

                                  // Truncate if length > 18
                                  const maxLength = 18;
                                  const displayText =
                                    addedByName.length > maxLength
                                      ? addedByName?.slice(0, maxLength) + "..."
                                      : addedByName;

                                  return (
                                    <Tooltip
                                      title={addedByName}
                                      arrow
                                      placement="top"
                                      disableHoverListener={
                                        addedByName.length <= maxLength
                                      }
                                    >
                                      <span>{displayText}</span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  const updatedByName = v?.updatedBy?.name
                                    ? CapitalizeFirstLetter(v.updatedBy.name)
                                    : "-";

                                  // If it's dash, style it differently
                                  if (updatedByName === "-") {
                                    return (
                                      <span className="text-gray-400">-</span>
                                    );
                                  }

                                  const maxLength = 18;
                                  const displayText =
                                    updatedByName.length > maxLength
                                      ? updatedByName?.slice(0, maxLength) +
                                        "..."
                                      : updatedByName;

                                  return (
                                    <Tooltip
                                      title={updatedByName}
                                      arrow
                                      placement="top"
                                      disableHoverListener={
                                        updatedByName.length <= maxLength
                                      }
                                    >
                                      <span>{displayText}</span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>

                              {(role == -1 || role == 0 || role == 4) && (
                                <TableCell
                                  className={styles.tableRow}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <Box className="flex items-center gap-2">
                                    <Tooltip title="Assign Vendor Partner">
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();

                                          setSelectedInstallationPartnerData(v);
                                          setOpenIPModal(true);
                                        }}
                                      >
                                        <PersonAddAlt fontSize="small" />
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip
                                      title={
                                        v?.vendorData?.length > 0 ? (
                                          <div>
                                            {v.vendorData.map((s, i) => (
                                              <div key={s.id ?? i}>
                                                {i + 1}. {s.vendorBusinessName}
                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          "No VP Assigned"
                                        )
                                      }
                                      arrow
                                    >
                                      <span style={{ display: "inline-block" }}>
                                        {v?.vendorData?.length > 0
                                          ? `${truncateText(v.vendorData[0]?.vendorBusinessName, 15)}${
                                              v.vendorData.length > 1
                                                ? ` +${v.vendorData.length - 1}`
                                                : ""
                                            }`
                                          : "Select VP"}
                                      </span>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                              )}
                              <TableCell
                                className={styles.tableRow}
                                onClick={(e) => e.stopPropagation()}
                                style={{ textAlign: "center" }}
                              >
                                {(() => {
                                  // FIX: Check if addedBy is null/undefined, not the string "Self"
                                  const isAddedBySelf = !v?.addedBy?.name;

                                  // If added by is "Self" (app onboarded), show ReferenceAssignmentModal
                                  if (isAddedBySelf) {
                                    return (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <ReferenceAssignmentModal
                                          ipData={v}
                                          getIPList={getInstallationPartnerList}
                                          initialSourceUser={v?.sourceUser}
                                          users={users}
                                          onChange={() => {
                                            getInstallationPartnerList();
                                          }}
                                          userRole={role}
                                        />
                                      </div>
                                    );
                                  } else {
                                    // If not "Self", show the sourceUser information if it exists
                                    if (v?.sourceUser?.name) {
                                      const sourceUserName =
                                        CapitalizeFirstLetter(
                                          v.sourceUser.name,
                                        );
                                      const maxLength = 18;
                                      const displayText =
                                        sourceUserName.length > maxLength
                                          ? sourceUserName.slice(0, maxLength) +
                                            "..."
                                          : sourceUserName;

                                      return (
                                        <Tooltip
                                          title={sourceUserName}
                                          arrow
                                          placement="top"
                                          disableHoverListener={
                                            sourceUserName.length <= maxLength
                                          }
                                        >
                                          <div style={{ textAlign: "center" }}>
                                            <span className="font-medium">
                                              {displayText}
                                            </span>
                                          </div>
                                        </Tooltip>
                                      );
                                    } else {
                                      // Show empty state for admin-created IPs without source user
                                      return (
                                        <span className="text-gray-400">
                                          Admin
                                        </span>
                                      );
                                    }
                                  }
                                })()}
                              </TableCell>

                              {role != "1" && (
                                <TableCell
                                  className={styles.tableRow}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="flex justify-center">
                                    <Tooltip title="Click">
                                      <IconButton
                                        onClick={(e) =>
                                          handleIconOpen(e, v._id)
                                        }
                                      >
                                        <MoreVertIcon
                                          style={{
                                            color: "var(--primary-color)",
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                  <Menu
                                    anchorEl={anchorEl}
                                    open={
                                      Boolean(anchorEl) &&
                                      selectedRowId === v._id
                                    }
                                    onClose={handleIconClose}
                                    keepMounted
                                  >
                                    {/* Details Section */}
                                    {(localStorage.getItem("role") === "-1" ||
                                      localStorage.getItem("role") === "0" ||
                                      localStorage.getItem("role") === "4") && (
                                      <MenuItem
                                        onClick={(e) => {
                                          handleEditClick(e, v, "edit");
                                          handleIconClose(); // Close the menu
                                          setIdForView(null);
                                        }}
                                        disabled={isActionLoading}
                                      >
                                        <EditOutlinedIcon
                                          style={{ color: "#6b7280" }}
                                        />
                                        <p className="ml-2 font-semibold text-[#6b7280]">
                                          Edit
                                        </p>
                                      </MenuItem>
                                    )}
                                    {localStorage.getItem("role") == "-1" && (
                                      <MenuItem
                                        onClick={
                                          (e) =>
                                            handlePaymentClick(e, v, "payments")
                                          // handleEditModal(e, v, "payments")
                                        }
                                      >
                                        <CurrencyRupeeOutlinedIcon
                                          style={{ color: "#6b7280" }}
                                        />
                                        <p className="ml-2 font-semibold text-[#6b7280]">
                                          Payments
                                        </p>
                                      </MenuItem>
                                    )}

                                    {localStorage.getItem("role") == "-1" && (
                                      <MenuItem
                                        onClick={(e) => handleDelete(e, v)}
                                      >
                                        <DeleteOutlinedIcon
                                          style={{ color: "red" }}
                                        />{" "}
                                        <p className="ml-2 font-semibold text-[red]">
                                          Delete
                                        </p>
                                      </MenuItem>
                                    )}
                                  </Menu>
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={headCells?.length}
                          sx={{ borderBottom: "none" }}
                        >
                          <div className="flex justify-center items-center h-64">
                            No Installation Partner Found
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </Table>
                </TableContainer>
                <hr
                  className="mt-2 bg-gray-200 "
                  style={{ border: "0.5px solid var(--light-grey-color)" }}
                />

                <div className="flex items-center justify-between ">
                  <FormControl
                    variant="standard"
                    size="small"
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                      "& .MuiInputBase-root:before": { borderBottom: "none" },
                      "& .MuiInputBase-root:after": { borderBottom: "none" },
                      "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                    }}
                  >
                    <InputLabel
                      id="page-size-label"
                      sx={{
                        position: "static",
                        transform: "none",
                        fontSize: "14px",
                        marginRight: "8px",
                        marginTop: "2px",
                      }}
                    >
                      Rows
                    </InputLabel>
                    <Select
                      labelId="page-size-label"
                      value={pageSize}
                      onChange={handlePageSizeChange}
                      label="Rows"
                    >
                      {pageSizeOptions.map((size) => (
                        <MenuItem key={size} value={size}>
                          {size}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <GlobalSnackbar
                    snackbar={snackbar}
                    handleClose={handleSnackbarClose}
                  />

                  <Pagination
                    className="p-2 flex justify-center"
                    count={totalPages}
                    page={page}
                    onChange={handlePageChange}
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#418cff", // Blue background for selected
                        color: "#fff", // White text for selected
                      },
                      "& .MuiPaginationItem-root.Mui-selected:hover": {
                        backgroundColor: "#3366cc", // Darker blue on hover
                      },
                      "& .MuiPaginationItem-root": {
                        "&:hover": {
                          backgroundColor: "#ddd", // Light gray for hovered items
                        },
                      },
                    }}
                  />
                </div>
              </>
            )}
          </Paper>
        ) : (
          <div className={styles.tableLoading}>
            <CircularProgress />
          </div>
        )}
      </Box>
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        ipModalOpen && (
          <IpPaymentsModal
            ipModalOpen={ipModalOpen}
            setIpModalOpen={setIpModalOpen}
            selectedInstallationPartnerData={ipPayment}
            ipData={selectedInstallationPartnerData}
            ipCampaignData={ipCampaignData}
            // setSelectedInstallationPartnerData={
            //   setSelectedInstallationPartnerData
            // }
          />
        )
      )}
      {isImage && (
        <Modal
          open={isImage}
          onClose={() => {
            setIsImage(false);
            setSelectedImage(null);
          }}
          className="flex items-center justify-center backdrop-blur-sm"
        >
          <div className="relative w-[500px] h-[450px] bg-[var(--disabled-color)] flex justify-center items-center">
            {/* MUI Close Icon */}
            <IconButton
              onClick={() => {
                setIsImage(false);
                setSelectedImage(null);
              }}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                color: "white",
                bgcolor: "black",
                "&:hover": {
                  bgcolor: "gray",
                },
              }}
            >
              <CloseIcon />
            </IconButton>

            {selectedImage &&
              (selectedImage.endsWith(".pdf") ? (
                <embed
                  src={selectedImage}
                  type="application/pdf"
                  className="object-contain  min-w-[70%] min-h-[70%] max-w-[80%] max-h-[80%]"
                />
              ) : (
                <img
                  src={selectedImage}
                  alt="Certificate"
                  className="object-contain  min-w-[70%] min-h-[70%] max-w-[80%] max-h-[80%]"
                />
              ))}
          </div>
        </Modal>
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isModalOpen && (
          <InstallationPartnerOnboardingForm
            setSnackbar={setSnackbar}
            getInstallationPartnerList={getInstallationPartnerList}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            selectedInstallationPartnerData={selectedInstallationPartnerData}
            setSelectedInstallationPartnerData={
              setSelectedInstallationPartnerData
            }
            fetchIps={fetchIps}
            searchInputs={searchInputs}
            pageSize={pageSize}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isInstallationPartnerModalOpen && (
          <InstallationPartnerModal
            isInstallationPartnerModalOpen={isInstallationPartnerModalOpen}
            setIsInstallationPartnerModalOpen={
              setIsInstallationPartnerModalOpen
            }
            setAnchorEl={setAnchorEl}
            setSnackbar={setSnackbar}
            selectedInstallationPartnerData={selectedInstallationPartnerData}
            setSelectedInstallationPartnerData={
              setSelectedInstallationPartnerData
            }
          />
        )
      )}
      {openIPModal && (
        <IPAssignModal
          open={openIPModal}
          onClose={() => {
            setOpenIPModal(false);
            setSelectedInstallationPartnerData(null);
          }}
          initialSelected={selectedInstallationPartnerData?.vendorData || null}
          // vendorId={selectedVendorId}
          // getVendorList={refreshWithCurrentFilters}'
          getInstallationPartners={getInstallationPartnerList}
          ipId={selectedInstallationPartnerData?._id}
          getIPList={getInstallationPartnerList}
          vpList={true}
        />
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        isTrashModalOpen && (
          <DeletedUsersRestore
            list={allDeletedIps}
            type="IP"
            openModal={isTrashModalOpen}
            loading={isTrashLoading}
            getAllDeletedUsers={getALLDeletedIps}
            setIsTrashModalOpen={setIsTrashModalOpen}
            setTrashLoading={setTrashLoading}
            getAllList={getInstallationPartnerList}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        createModal && (
          <CreateSlotIP
            setCreateModal={setCreateModal}
            createModal={createModal}
          />
        )
      )}
      {isActionLoading ? (
        <CustomLoading />
      ) : (
        slotModalView && (
          <ViewSlotsInstallationPartner
            setSlotModalView={setSlotModalView}
            slotModalView={slotModalView}
          />
        )
      )}

      {
        <OtpVerificationModal
          isOpen={isModalOtpOpen}
          onClose={() => setIsModalOtpOpen(false)}
          otp={otp}
          handleOtpChange={handleOtpChange}
          handleKeyDown={handleKeyDown}
          firstInputRef={firstInputRef}
          isVerified={isVerified}
          handleVerifyOtp={handleVerifyOtp}
          otpError={otpError}
        />
      }
    </div>
  );
}
